import { AlertTriangle, CheckCircle, Info, X, XCircle } from 'lucide-react'
import { useToastStore, type ToastKind } from './toastStore'

const STYLE: Record<ToastKind, { Icon: typeof Info; box: string; icon: string }> = {
  success: {
    Icon: CheckCircle,
    box: 'border-emerald-200 bg-emerald-50 dark:border-emerald-900 dark:bg-emerald-950/60',
    icon: 'text-emerald-600 dark:text-emerald-400',
  },
  error: {
    Icon: XCircle,
    box: 'border-red-200 bg-red-50 dark:border-red-900 dark:bg-red-950/60',
    icon: 'text-red-600 dark:text-red-400',
  },
  warning: {
    Icon: AlertTriangle,
    box: 'border-amber-200 bg-amber-50 dark:border-amber-900 dark:bg-amber-950/60',
    icon: 'text-amber-600 dark:text-amber-400',
  },
  info: {
    Icon: Info,
    box: 'border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800',
    icon: 'text-primary',
  },
}

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts)
  const remove = useToastStore((s) => s.remove)
  if (toasts.length === 0) return null
  return (
    <div
      className="pointer-events-none fixed right-4 top-4 z-[200] flex w-full max-w-sm flex-col gap-2"
      aria-live="polite"
      aria-atomic="false"
    >
      {toasts.map((t) => {
        const s = STYLE[t.kind]
        return (
          <div
            key={t.id}
            role="status"
            className={`pointer-events-auto flex items-start gap-3 rounded-md border p-3 shadow-lg animate-slide-in ${s.box}`}
          >
            <s.Icon size={18} className={`mt-0.5 shrink-0 ${s.icon}`} />
            <div className="min-w-0 flex-1">
              <p className="text-xs font-semibold text-default">{t.title}</p>
              {t.message && <p className="mt-0.5 text-xs text-muted">{t.message}</p>}
            </div>
            <button type="button" onClick={() => remove(t.id)} className="icon-btn !p-1" aria-label="Dismiss">
              <X size={14} />
            </button>
          </div>
        )
      })}
    </div>
  )
}
